// extracted by mini-css-extract-plugin
var _1 = "LoginForm-module__content___Pp4Ht";
var _2 = "LoginForm-module__forgotPassword___Dwcbv";
var _3 = "LoginForm-module__gap___gs3yh";
var _4 = "LoginForm-module__heading___FXS3v";
var _5 = "LoginForm-module__sectionDivider___dNygA";
var _6 = "LoginForm-module__wrapper___hnQ31";
export { _1 as "content", _2 as "forgotPassword", _3 as "gap", _4 as "heading", _5 as "sectionDivider", _6 as "wrapper" }
